import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from "@material-ui/core";
import { createQboInvoice } from "../actions/dashboardAction";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function QboInvoice(props) {
  const { open, handleClose, invoiceId, accountId, onQboSuccess} = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const accountId = window.sessionStorage.("accountId");
  // console.log(invoiceId, accountId, 'invoiceId, accountId')
  const handleSendToQbo = () => {
    // console.log(invoiceId, accountId, 'invoiceId, accountId')

    if (!invoiceId || !accountId) {
      // console.log("Missing invoiceId or accountId");
      return;
    }
    setLoading(true);

    const payload = {
       invoiceId: invoiceId,  
       accountId: accountId,
    };

    // console.log("Sending QBO payload:", payload);

    dispatch(createQboInvoice(payload, (status) => {
    //   console.log("QBO Invoice creation callback executed:", status);
      setLoading(false);
       if (status === true || status === "success") {
        onQboSuccess && onQboSuccess();
       }
    //   setTimeout(() => {
        handleClose();
    //   }, 100);
    }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={'sm'}
      disableScrollLock
    >
      <DialogTitle>
        Invoice Fully Paid!
        <IconButton onClick={() => { handleClose() }} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <p style={{ lineHeight: '24px' }}>This invoice has already been paid in full. Would you like to send it to <b>QuickBooks Online</b> now to keep your accounting in sync?
        </p>
        <p style={{ fontSize: "14px", opacity: 0.8 }}><i>Note: You can send it anytime using “Send invoice to QBO”</i></p><br />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained"
            disabled={loading}
            style={{
              color: "white",
              backgroundColor: "black",
              marginRight: "10px",
              height: 'fit-content',
              transition: "0.3s"
            }}
            onClick={handleSendToQbo}
            endIcon={
              loading ? (<CircularProgress style={{ width: 22, height: 22, color: "#fff" }} />
              ) : null
            }
          >
            Yes, send to QBO
          </Button>

          <Button variant="outlined"
            style={{
              background: "#fff",
              color: "#000",
              height: 'fit-content',
              paddingTop: "5 !important",
              paddingBottom: "5 !important"
            }}
            onClick={handleClose}
          >
            No, I’ll do it later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
